export const MERCHANTS = "MERCHANTS";
export const BRANDS = "BRANDS";
export const COLLECTIONS = "COLLECTIONS";

export enum SpaceView {
    MerchantDrive = "merchantDrive",
    MyDrive = "myDrive",
    SharedWithMe = "sharedWithMe",
    MerchantDriveTrash = "merchantDriveTrash",
    MyDriveTrash = "myDriveTrash",
    Starred = "starred",
}

export const removeAssortmentExtRegex = /^(.*)\.assort$/i;

export const removeWhiteboardExtRegex = /^(.*)\.board$/i;

export const removeShortcutExtRegex = /^(.*)\.short$/i;

export const removeRollupExtRegex = /^(.*)\.roll$/i;

export interface IReadSnapshotFilters {
    doorDimensionId: string;
    deliveryDimensionId: string;
    sizeDimensionId: string;
    doorId?: string;
    productId?: string;
    collectionId?: string;
}

export const buildMerchantCacheKeys = (userId: string, merchantId: string, brandId?: string) => {
    const compositeIds = { userId, merchantId, brandId };

    return [MERCHANTS, compositeIds];
};
